import { metadata } from '@atlaskit/object/metadata';

import { getObjectName } from './get-object-name';
import { type ObjectData } from './types';

let objectsPromise: Promise<Record<string, ObjectData> | undefined> | null = null;

// get object info as a Promise which returns a Record
export const getObjects: () => Promise<Record<string, ObjectData> | undefined> = () => {
	if (!objectsPromise) {
		objectsPromise = Promise.all(
			Object.entries(metadata).map(async ([name, meta]) => {
				const object = await meta.object.packageLoader();
				return { name, object: object.default, meta };
			}),
		)
			.then((newData) =>
				newData
					.map((object) => {
						return {
							[object.name]: {
								keywords: object.meta.keywords,
								component: object.object,
								componentName: object.meta.object.componentName,
								packageName: object.meta.object.package,
								objectName: getObjectName(object.name),
								color: object.meta.color,
								icon: object.meta.icon,
								iconPackage: object.meta.iconPackage,
							} as ObjectData,
						};
					})
					.reduce((acc, b) => ({ ...acc, ...b })),
			)
			.catch(() => {
				return undefined;
			});
	}

	return objectsPromise;
};
